if (!customElements.get('colour-swatch-picker')) {
  customElements.define(
    'colour-swatch-picker',
    class ColourSwatchPicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.querySelectorAll('[data-colour-swatch-toggle]').forEach((toggleButton) => {
          const group = toggleButton.closest('[data-colour-swatch-group]') || this;
          const overflowIndicator = group.querySelector('[data-colour-swatch-overflow]');

          toggleButton.addEventListener('click', () => {
            const expanded = group.classList.toggle('is-expanded');
            toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            toggleButton.textContent = expanded
              ? toggleButton.dataset.showLessLabel
              : toggleButton.dataset.showMoreLabel;

            if (overflowIndicator) {
              overflowIndicator.hidden = expanded;
            }
          });
        });

        this.addEventListener('change', (event) => {
          const input = event.target;
          if (input.type !== 'radio') return;

          const groups = this.querySelectorAll('[data-colour-swatch-group]');
          if (groups.length) {
            groups.forEach((group) => {
              const selectedValue = group.querySelector('[data-selected-swatch-value]');
              if (!selectedValue) return;
              selectedValue.textContent = group.contains(input) ? input.value : '';
            });
            return;
          }

          const selectedValue = this.querySelector('[data-selected-swatch-value]');
          if (selectedValue) {
            selectedValue.textContent = input.value;
          }
        });
      }
    }
  );
}
